import React, { useEffect, useRef, useState } from 'react';
import { OTPublisher, OTSession, OTStreams, OTSubscriber, preloadScript } from 'opentok-react';
import io from 'socket.io-client';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Grid, Typography, CircularProgress, IconButton, Tooltip } from '@mui/material';
import useStyles from './talkStyles';
import * as patientActions from '../../core/Store/Actions/PatientActions';
import * as registerActions from '../../core/Store/Actions/RegisterActions';
import { SOCKET_URL, API_KEY_DEV, ROOM_URGENT_CARE } from '../../env';
import Subscriber from './subscriber';
import Publisher from './publisher';
import { MdOutlineCallEnd, MdOutlineVideocam, MdOutlineVideocamOff, MdMicNone, MdOutlineMicOff } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { AiOutlineLeft } from 'react-icons/ai';
import { } from '../../assets';
import './talkStyles.css';


const TalkToProvider = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const userData = useSelector(state => state.registerReducer.userVerifyData);
    const fhir_patient_id = userData.user?.person?.fhir_patient_id || '';
    const providerData = useSelector(
        state => state.patientReducer.validateUser,
    );
    const docList = useSelector(
        state => state.patientReducer.docList,
    );
    const dispatch = useDispatch();
    const uuid = userData.user.person.uuid;
    const access_token = providerData && providerData.access_token;
    const childrenData = useSelector(state => state.patientReducer.selectedChildData);
    const roomStatus = useSelector(
        state => state.patientReducer.roomStatus,
    );
    const callID = useSelector(state => state.patientReducer.callID);
    const addUserStatus = useSelector(
        state => state.patientReducer.addUserStatus,
    );
    const roomKeys = useSelector(state => state.patientReducer.roomKeys);

    // const [generateCallID, setGenerateCallID] = useState(false);
    // const [socket, setSocket] = useState(null);
    // const [roomKey, setRoomKey] = useState({});
    const [generateCallID, setGenerateCallID] = useState(false);
    const [connected, setConnected] = useState(false);
    const [subConnected, setSubConnected] = useState(false);
    const [audio, setAudio] = useState(true);
    const [video, setVideo] = useState(true);
    const [roomKey, setRoomKey] = useState({});
    const [alreadyVisited, setAlreadyVisited] = useState(false);
    const [loading, setLoading] = useState(false);
    const [streamID, setStreamID] = useState('');
    const [socket, setSocket] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    //const isLoading = useSelector(state => state.talkToProviderReducer.loading);
    const sessionRefr = useRef(null);
    const [error, setError] = useState();
    const [subscribed, setSubscribe] = useState(false);
    const [showDoctorLeave, setShowDoctorLeave] = useState({ open: false });
    const [withError, setWithError] = useState(false);
    const [addUserCall, setAddUserCall] = useState(true);

    const medicationStore = useSelector(
        state => state.patientReducer.medicationStore,
    );
    const allergiesStore = useSelector(
        state => state.patientReducer.allergiesStore,
    );
    const medicalConditionStore = useSelector(
        state => state.patientReducer.medicalConditionStore,
    );
    const symptomsStore = useSelector(
        state => state.patientReducer.symptomsStore,
    );

    useEffect(() => {
        (async () => {
            if (access_token) {
                dispatch(
                    patientActions.getDocFromAlias(
                        { alias: ROOM_URGENT_CARE },
                        access_token,
                    ),
                );
            }
        })();
    }, [access_token]);
    useEffect(() => {
        (async () => {
            if (roomKeys) {
                setRoomKey(roomKeys[0]);
            }
        })();
    }, [roomKeys]);
    useEffect(() => {
        (async () => {
            if (access_token && Object.keys(roomStatus).length == 0) {
                let payload;
                if (childrenData && childrenData.child_id) {
                    payload = { patient_id: childrenData.child_id }
                } else {
                    payload = { patient_id: providerData.id }
                }
                dispatch(
                    patientActions.checkRoomStatus(
                        payload,
                        access_token,
                    ),
                );
            }
        })();
    }, [access_token]);
    useEffect(() => {
        (async () => {
            if (access_token && generateCallID) {
                setGenerateCallID(false);
                const params = {
                    patientId: childrenData && childrenData.child_id ? childrenData.child_id : providerData.id,
                    patientEmail: userData.user.email,
                    patientDob: childrenData && childrenData.dateofbirth ? childrenData.dateofbirth : userData.user.person.birth_date_at || '',
                    uuid: uuid,
                    staffid: 500,
                    call_started: moment(Date.now()).format('YYYY/MM/DD'),
                    room_name: ROOM_URGENT_CARE,//room && room.name,
                    call_type: 'connect',
                    device_type: window.navigator.userAgent,
                };
                dispatch(
                    patientActions.generateCallIdByPatientId(params, access_token),
                );
            }
        })();
    }, [generateCallID]);
    useEffect(() => {
        // (async () => {
        if (
            access_token &&
            docList &&
            docList.length > 0 &&
            Object.keys(callID).length > 0 && addUserCall
        ) {
            setAddUserCall(false);
            const firstDoc = docList[0];
            const params = {
                docId: firstDoc.id,
                groupId: firstDoc.group_id,
                userId: childrenData && childrenData.child_id ? childrenData.child_id : providerData.id,//providerData.id,
                symptom: JSON.stringify(symptomsStore) || '["No Symptoms"]',// JSON.stringify(pVer.symptom),
                allergy: JSON.stringify(allergiesStore) || '["No Allergies"]',// JSON.stringify(pVer.allergy),
                medication: JSON.stringify(medicationStore) || '["No Medications"]',// JSON.stringify(pVer.medication),
                medical_condition: JSON.stringify(medicalConditionStore) || '["No Pre-existing medical conditions"]',// JSON.stringify(pVer.medical_condition),
                call_id: `${callID.call_id}`,
                date_of_injury: '',
                state_of_injury: '',
                employer_name: '',
                alias: ROOM_URGENT_CARE,
            };
            dispatch(patientActions.addUserToWaitingRoom(params, access_token));
        }
        // })();
    }, [callID]);
    useEffect(() => {
        (async () => {
            if (
                access_token &&
                Object.keys(callID).length > 0 &&
                docList.length > 0 &&
                Object.keys(roomStatus).length > 0 &&
                Object.keys(addUserStatus).length > 0
            ) {
                dispatch(
                    patientActions.getOpentokRoomKeys(
                        { id: childrenData && childrenData.child_id ? childrenData.child_id : providerData.id },
                        access_token,
                    ),
                );

                const firstDoc = docList[0];

                const soc = io(SOCKET_URL);
                if (!socket) {
                    await setSocket(soc);
                    soc.on('callDisconnectedByDoc', handleDisconnectedByDoctor);
                }
                soc.emit('userjoin', {
                    waitingId: callID.call_id,
                    docid: 500,
                    groupId: firstDoc.group_id,
                });
            }
        })();
    }, [access_token, callID, docList, addUserStatus]);
    const handleDisconnectedByDoctor = data => {
        if (data.callId && Number(data.callId) === callID.call_id)
            setShowDoctorLeave({ open: true, status: data.status });
    };

   
    useEffect(() => {
        setWithError(false);
        if (!roomKey) setWithError(true);
    }, [roomKey]);
    const handleQuit = (isNoemit) => {
        if (callID && callID.call_id)
            dispatch(
                patientActions.callEndByPatient(
                    { callid: callID.call_id, isNotConnected: true },
                    access_token,
                ),
            );
        dispatch(
            patientActions.providerSettings(ROOM_URGENT_CARE, access_token),
        );
        if (socket && !isNoemit) {
            socket.emit('callDisconnectedByDoc', {
                callId: callID.call_id,
            });
        }

        dispatch(
            patientActions.notifyProvider(
                {
                    roomName: ROOM_URGENT_CARE,// room && room.name,
                    firstName: childrenData && childrenData.first_name ? childrenData.first_name : userData.user.person.first_name,
                    patientLeft: true,
                },
                access_token,
            ),
        );
        dispatch(
            patientActions.disconnectReason(
                {
                    sessionId: roomKey && roomKey.session,
                    reason: 'clientDisconnected',
                },
                access_token,
            ),
        );
        // dispatch(validClientActions.invalidateRequest({'access_token': access_token}, access_token));
        dispatch(patientActions.clearDataRequest());
        dispatch(patientActions.onRemoveSelectedChild());
        navigate('/room/thanks');
        // dispatch(setDrawerVisibility(true));
        // setTimeout(() => {
        //     try {
        //         NavigationService.navigate('home');
        //     } catch (error) {
        //         console.log('Error');
        //     }
        // }, 3000);
    };
    useEffect(() => {
        (async () => {
            if (
                access_token &&
                Object.keys(addUserStatus).length > 0 &&
                Object.keys(roomStatus).length > 0
            ) {
                const params = {
                    roomName: ROOM_URGENT_CARE, //room && room.name,
                    firstName: childrenData && childrenData.first_name ? childrenData.first_name : userData.user.person.first_name,
                };
                dispatch(patientActions.notifyProvider(params, access_token));
            }
        })();
    }, [access_token, roomStatus, addUserStatus]);

    const sessionEvents = {
        sessionConnected: () => {
            console.log('Just connected');
            setConnected(true);
        },
        sessionDisconnected: () => {
            console.log('Yet to be connected');
            setConnected(false);
        },
        connectionDestroyed: ({ sessionId }) => {
            dispatch(patientActions.clearDataRequest());
            dispatch(patientActions.onRemoveSelectedChild());
            try {
                dispatch(patientActions.clearDataRequest());
                navigate('/room/thanks');
                sessionRefr &&
                    sessionRefr.current &&
                    sessionRefr.current.eventHandlers.sessionDisconnected();//disconnectSession();
                // NavigationService.navigate('home');
                //dispatch(setDrawerVisibility(true));
            } catch (error) {
                console.log(error);
            }
        },
    };
    const onError = err => {
        console.log(`Failed to connect: ${err.message}`);
        setError(`Failed to connect: ${err.message}`);
    };

    const handleCloseDoctorLeaveModal = () => {
        if (showDoctorLeave.status !== 'PENDING') {
            handleQuit(true);
        }
        setShowDoctorLeave({ ...showDoctorLeave, open: false });
    };
    const renderDoctorDisconnectModal = () => (
        <Dialog
            open={showDoctorLeave.open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Call Disconnected By Doctor
          </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {showDoctorLeave.status === 'PENDING'
                        ? 'Please wait, the doctor will be back shortly.'
                        : 'The doctor has ended the call. Thank you!'}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDoctorLeaveModal} color="primary">
                    Close
            </Button>
            </DialogActions>
        </Dialog>
    );
    const handleSetAudio = () => {
        console.log('audio change', audio);
        setAudio(!audio);
    };

    const handleSetVideo = () => {
        console.log('Video change', video);
        setVideo(!video);
    };
    const subSessionEvents = {
        connected: () => {
            console.log('Sub connected');
            setSubConnected(true);
        },
        disconnected: () => {
            console.log('Sub to be connected');
            setSubConnected(false);
        },
        videoEnabled: ({ stream }) => {
            setStreamID(stream.streamId);
        },
    };
    const handleEndCall = () => {
        setShowAlert(true);
        //dispatch(doSetVideoConfConfirmation(true));
    };
    const apiFailed = useSelector(state => state.registerReducer.apiFailed);
    const [openModal, setOpen] = useState(false);
    const [msg, setMsg] = useState('');
    const [errorType, setErrorType] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        dispatch(registerActions.onErrorOccured({}));
        setErrorType(false);
        if (!errorType) {
            navigate('/');
        }
    };
    useEffect(() => {
        console.log("apiFailed Data", apiFailed);
        if (typeof apiFailed === 'object' && apiFailed !== null && Object.keys(apiFailed).length > 0) {
            setMsg(apiFailed.exception_message || apiFailed.status_message || apiFailed.message || 'Internal server error');
            handleClickOpen();
        } else if (apiFailed && typeof apiFailed == 'string' && String(apiFailed).length > 0) {
            setMsg(apiFailed || 'Something went wrong');
            setErrorType(true);
            handleClickOpen();
        }
    }, [apiFailed]);

    const erroDialog = () => (
        <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">Error</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {/* {`There is some problem with the request. Please call 1.844.900.2567 for further assistance`} */}
                    {`${msg}`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {errorType ?
                    <Button onClick={handleClose} color="primary">
                        Ok
                    </Button>
                    :
                    <Button onClick={handleClose} color="primary">
                        Go To Login
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
    return (
        <Container>
            {roomKey && roomKey.session && roomKey.token ? (
                <OTSession
                    apiKey={API_KEY_DEV}
                    sessionId={(roomKey && roomKey.session) || ''}
                    token={(roomKey && roomKey.token) || ''}
                    eventHandlers={sessionEvents}
                    ref={sessionRefr}
                    onError={onError}
                >
                    <div style={{
                        width: "100%",
                        backgroundColor: "white",
                        //height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        marginTop: '5%',
                        marginBottom: '2%'
                    }}>
                        <Typography className='topTitle'>Virtual Room
                                            <a href="" className="backArrow" onClick={(e) => { e.preventDefault(); handleEndCall() }}>
                                <AiOutlineLeft />Back</a>
                        </Typography>
                    </div>
                    {!subscribed &&
                        (<div style={{
                            width: '100%',
                            height: '100vh'
                        }}>
                            <div className="subGrid">
                                <div style={{ background: "white", overflowY: 'hidden', width: '100%' }} >
                                    <div style={{ paddingRight: '5%', paddingLeft: '5%' }} >
                                        {(
                                            <>
                                                <div>
                                                    <Typography align="center">
                                                        Please wait, we will be in touch shortly...
                                                </Typography>
                                                    <Typography component="div" align="center">
                                                        <CircularProgress color="secondary" />
                                                    </Typography>
                                                    <OTStreams>
                                                        <Subscriber onSubscribed={setSubscribe} />
                                                    </OTStreams>
                                                </div>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    // width:'100%'
                                                }}  //className={classes.publisherFull}
                                                >
                                                    <Publisher
                                                        session={
                                                            sessionRefr.current !== null
                                                                ? sessionRefr.current
                                                                : undefined
                                                        }
                                                        handleSetAudio={handleSetAudio}
                                                        handleSetVideo={handleSetVideo}
                                                        audio={audio}
                                                        video={video}
                                                        showAlert={showAlert}
                                                        setShowAlert={setShowAlert}
                                                        onQuit={handleQuit}
                                                        height={'50vh'}
                                                        marginBottom={'0%'}
                                                    />
                                                </div>
                                                <Typography className="allowTitle">
                                                    Please make sure you allow the portal to access your camera and
                                                    microphone when prompted.
                                                </Typography>
                                            </>
                                        )}</div>
                                    {/* <div style={{
                                        position: 'absolute',
                                        bottom: '10%',
                                        left: '20%',
                                        flexDirection: 'row'
                                    }}>
                                        <a href="" style={{ color: '#000000', display: "inline", textDecoration: 'none', }}>{`1.844.900.AKOS(2567) `}</a>
                                        <a href="" style={{
                                            color: '#000000', display: "inline", textDecoration: 'none',
                                        }}>| info@akosmd.com</a>

                                    </div> */}
                                </div>
                                <div style={{ background: "white", height:'auto', width: '100%' }}>
                                    <div style={{ padding: '5%' }}>
                                        {
                                            (<div>
                                                <Typography className="patientTitle"  >
                                                    Hello{' '}
                                                    {`${userData.user.person.first_name} ${
                                                        userData.user.person.last_name
                                                        } `}
                                                    {`!`}
                                                </Typography>
                                                <Typography className="patientSubtitle" align="center">
                                                    {`Thanks for joining our consultation room.\nOur providers are
                                    aware of your arrival in this waiting room and they will be with
                                    you shortly.`}
                                                </Typography>
                                            </div>)}</div>
                                    {/* <div style={{
                                        position: 'absolute',
                                        bottom: '10%',
                                        right: '5%',
                                        //left: '70%',
                                        flexDirection: 'row'
                                    }}>
                                        <a href="" style={{ color: '#000000', display: "inline", textDecoration: 'none' }}>{`Copyright ©2022 Akos `}</a>
                                        <a href="" style={{
                                            color: '#000000', display: "inline", textDecoration: 'none'
                                        }}>| All Rights Reserved</a>
                                    </div> */}
                                </div>
                            </div>
                        </div>)}
                    <Grid
                        container
                        alignItems="center"
                        justify="center"
                        className={classes.parentContainer}
                    >
                        {/* {!subscribed &&
                            (<Grid item xs={12} lg={12} className={classes.text}
                            >
                                <Typography variant="h6" align="center">
                                    Hello{' '}
                                    {`${userData.user.person.first_name} ${
                                        userData.user.person.last_name
                                        } `}
                                    {`!`}
                                </Typography>
                                <Typography style={{
                                    textAlign: 'left',
                                    fontSize: '18px',
                                    fontFamily: 'manrope',
                                    fontStyle: 'normal',
                                    fontWeight: '400',
                                    marginBottom: '1%', color: '#565656'
                                }} align="center">
                                    {`Thanks for joining our consultation room.\nOur providers are
                                    aware of your arrival in this waiting room and they will be with
                                    you shortly.`}
                                </Typography>
                                <Typography align="center">
                                    <em>
                                        Please make sure you allow the portal to access your camera and
                                        microphone when prompted.
                                </em>
                                </Typography>
                            </Grid>)} */}

                        {error ? <div id="error">{error}</div> : null}
                        {/* {!subscribed && (
                            <>
                                <Grid item xs={12} className={classes.loadingText}
                                >
                                    <Typography variant="h6" align="center">
                                        Please wait, we will be in touch shortly...
                                    </Typography>
                                    <Typography component="div" align="center">
                                        <CircularProgress color="secondary" />
                                    </Typography>
                                    <OTStreams>
                                        <Subscriber onSubscribed={setSubscribe} />
                                    </OTStreams>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}  //className={classes.publisherFull}
                                    >
                                        <Publisher
                                            session={
                                                sessionRefr.current !== null
                                                    ? sessionRefr.current
                                                    : undefined
                                            }
                                            handleSetAudio={handleSetAudio}
                                            handleSetVideo={handleSetVideo}
                                            audio={audio}
                                            video={video}
                                            showAlert={showAlert}
                                            setShowAlert={setShowAlert}
                                            onQuit={handleQuit}
                                        />
                                    </div>
                                </Grid>
                            </>
                        )} */}

                        {subscribed && (
                            <>
                                <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }} //className={classes.OT_subscriber}
                                >
                                    <OTStreams >
                                        <Subscriber onSubscribed={setSubscribe} />
                                    </OTStreams>
                                </div>
                                <div className='publisherView'   //className={classes.publisher}
                                >
                                    <Publisher
                                        session={
                                            sessionRefr.current !== null ? sessionRefr.current : undefined
                                        }
                                        handleSetAudio={handleSetAudio}
                                        handleSetVideo={handleSetVideo}
                                        audio={audio}
                                        video={video}
                                        showAlert={showAlert}
                                        setShowAlert={setShowAlert}
                                        onQuit={handleQuit}
                                        height={'20vh'}
                                        marginBottom={'18%'}
                                    />
                                </div>
                            </>
                        )}
                    </Grid>

                    <Grid item xs={12} className={classes.controls}
                    >
                        <Tooltip title="End Call">
                            <IconButton size='large' onClick={handleEndCall} style={{ marginRight: '3%' }}>
                                <MdOutlineCallEnd color="red" fontSize="100%" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Toggle Video">
                            <IconButton size='large' onClick={handleSetVideo} style={{ marginRight: '3%' }}>
                                {!video ? (
                                    <MdOutlineVideocamOff fontSize="100%" />
                                ) : (
                                        <MdOutlineVideocam fontSize="100%" />
                                    )}
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Mute/Unmute Audio">
                            <IconButton size='large' onClick={handleSetAudio} style={{ marginRight: '3%' }}>
                                {!audio ? (
                                    <MdOutlineMicOff fontSize="100%" />
                                ) : (
                                        <MdMicNone fontSize="100%" />
                                    )}
                            </IconButton>
                        </Tooltip>
                    </Grid>

                    {renderDoctorDisconnectModal()}
                </OTSession>) : <div>{erroDialog()}</div>}
        </Container>
    )
}

export default TalkToProvider
